import React from 'react';
import { OverviewMultiLocationSingleSubjectInnerLocation } from '../../pages/Data/partials';

export default function OverviewMultiLocationSingleSubject({ subjectData }) {
  const isThreeLocations = subjectData.locationCount === 3;
  return (
    <div className=" overview-main overview-multi-location">
      <div className={`overview-multi-country-wrapper ${isThreeLocations ? 'overview-multi-country-three' : ''}`} id="pnl_sub_overview">
        {subjectData.locations.map((e) => (
          <OverviewMultiLocationSingleSubjectInnerLocation location={e} key={`overview_multi_location_single_subject_inner_location_${e}`} subject={subjectData.subject} isTakingScreenshot={subjectData.isTakingScreenshot} />
        ))}
      </div>
    </div>
  );
}
